import TextArea from '@components/ui/inputs/text-field/text-area';
import { showNotification } from '@helpers/notification-helper';
import { createClientNote } from '@services/external/user.api';
import { Button, Col, Form, Row } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { NotesSC } from '../../notes.styled';
import { initialValues, validationSchema } from './add-note-form.schema';

interface AddNoteFormProps {
  afterSubmit?: () => void;
  userId: string;
}

const AddNoteForm: React.FunctionComponent<AddNoteFormProps> = ({ afterSubmit, userId }) => {
  const { formatMessage } = useIntl();

  const [, formOptions] = Form.useForm({
    initialValues,
    validationSchema,
    onSubmit: async (v, { resetForm }) => {
      try {
        await createClientNote(userId, v.note, '');
        afterSubmit?.();
        resetForm();
        showNotification({
          title: formatMessage({ id: 'life_id.notes.success' }),
          copy: '',
          type: 'SUCCESS',
        });
      } catch (error) {
        console.log(error);
        showNotification({
          title: formatMessage({ id: 'life_id.notes.error' }),
          copy: '',
          type: 'ERROR',
        });
      }
    },
    enableReinitialize: true,
  });

  return (
    <NotesSC>
      <Form
        {...formOptions}
        showFeedback={false}
        showLabel={false}
        style={{ width: '100%', padding: '16px' }}
      >
        <Row gutter={[16, 16]} align="end">
          <Col xs={9}>
            <Form.Field name="note" noStyle>
              <TextArea
                placeholder={formatMessage({ id: 'life_id.notes.textarea.placeholder' })}
                autoSize={{ minRows: 1, maxRows: 10 }}
                style={{ width: '100%' }}
              />
            </Form.Field>
          </Col>
          <Col xs={3}>
            <Form.Custom>
              {(f) => (
                <Button type="submit" loading={f.isSubmitting} size="medium" variant="primary">
                  {formatMessage({ id: 'life_id.notes.save' })}
                </Button>
              )}
            </Form.Custom>
          </Col>
        </Row>
      </Form>
    </NotesSC>
  );
};

export default AddNoteForm;
